// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/chat/:id\",\"regex\":\"^/chat/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/expert/:id\",\"regex\":\"^/expert/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/iframe/chat/:id\",\"regex\":\"^/iframe/chat/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/iframe/expert/:id\",\"regex\":\"^/iframe/expert/([^/]+)$\",\"paramNames\":[\"id\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/iframe\"}]}";globalThis["_sentryNextJsVersion"] = "16.0.1";import * as Sentry from "@sentry/nextjs";

// Only initialize Sentry in production on Vercel
if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
  Sentry.init({
    dsn: "https://7ce43038dbf6c99d257eacc443371422@o4508370772361216.ingest.de.sentry.io/4510023749271632",

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;